import styled, { css } from "styled-components";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { WinterToggle } from "../../../common/styles/WinterWheelToggle";

export const Wrapper = styled(Flex.Row)`
    position: relative;
    padding-top: 41.43%;

    ${WinterToggle} {
        position: absolute;
        bottom: -41px;
        right: 20px;
        z-index: 2;
    }

    @media ${getBreakpoint("down", "lg")} {
        ${WinterToggle} {
            display: none;
        }
    }

    html[dir="rtl"] & {
        ${WinterToggle} {
            left: 20px;
            right: auto;
        }
    }
`;

export const SpinPlayer = styled.div<{ isFullscreen?: boolean }>`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 100%;
    padding-top: 40.27%; /* = (446 /1160) * 100 */

    ${({ isFullscreen }) =>
        isFullscreen &&
        css`
            left: 50%;
            max-width: 374px;
            transform: translateX(-50%);

            @media ${getBreakpoint("up", "md")} {
                max-width: 768px;
            }

            @media ${getBreakpoint("up", "xl")} {
                max-width: 1600px;
            }
        `};
`;

export const SpinImage = styled.img<{ opacity: number; transition?: string; zindex?: number }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 374px;
    height: auto;
    pointer-events: none;
    user-select: none;
    opacity: ${(props) => props.opacity};

    @media ${getBreakpoint("up", "md")} {
        max-width: 768px;
    }

    @media ${getBreakpoint("up", "xl")} {
        max-width: 1600px;
    }

    ${({ transition }) =>
        transition &&
        css`
            transition: ${transition};
        `};
    ${({ zindex }) =>
        zindex &&
        css`
            z-index: ${zindex};
        `};
`;

export const SnowCanvas = styled.canvas`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 3;

    html[dir="rtl"] & {
        left: auto;
        right: 0;
    }
`;
